import React from 'react';
import Arrow from '../../../../assets/arrow.png';
import styles from './index.module.scss';
import cs from 'classnames';
import { translate } from '@shakkerai/util-i18n';
const HeaderNav = ({ config, getMore, category }) => {
  return (
    <div className="flex justify-between my-3">
      <div className="relative flex justify-center items-center">
        {config.category && category === '0' ? (
          <div className={cs('flex', styles.iconLabel)}>
            <span className="pl-[6px] pr-[14px] py-[2px]">{config.category}</span>
          </div>
        ) : null}
        <span className={cs('pb-[2px]', styles.tips)}>{config.alias}</span>
      </div>
      <div
        className={cs('cursor-pointer flex justify-center items-center', styles.more)}
        onClick={(e) => (e.stopPropagation(), getMore(config))}
      >
        <span>{translate('modelhub_tab_more')}</span>
        <img src={Arrow} className={cs('w-[5px] h-[11px] ml-[9px] relative', styles.arrow)} />
      </div>
    </div>
  );
};

export default HeaderNav;
